import { Box, Flex } from "@qws-org/ui-kit";
import type { FC } from "react";

import { NavbarItem } from "~/features/headerV4/components/NavbarItem";
import type { HeaderProps } from "~/features/headerV4/HeaderV4";

type BottomHeaderMenuListProps = HeaderProps & {
  currentPage: string;
  onNavlinkClick: (url: string, id: string) => void;
  closeBurgerMenu: () => void;
};
export const BottomHeaderMenuList: FC<BottomHeaderMenuListProps> = (props) => {
  const {
    data,

    clickHeaderSub,
    onCallAction,
    isActionInactive,
    getUrl,
    onNavlinkClick,
    currentPage,
  } = props;
  return (
    <Flex
      align="center"
      display="hidden"
      d={{
        display: "flex",
        flexDirection: "row",
        gap: 8,
      }}
      flexDirection={"row"}
      data-testid="header-bottom-menu"
    >
      {data?.menu?.action_items && (
        <>
          {data.menu.action_items
            ?.filter((action) => {
              if (action?.menu_action_items_id?.action) {
                return !isActionInactive(action.menu_action_items_id.action);
              }

              return true;
            })
            ?.map(
              (item, idx) =>
                item?.menu_action_items_id && (
                  <Box
                    p={{ px: 15 }}
                    width="100%"
                    md={{ width: "100%" }}
                    d={{ p: { px: 0 }, width: "auto", display: "block" }}
                    key={item?.menu_action_items_id.id}
                    display="hidden"
                    data-testid={`header-bottom-menu-item-${idx}`}
                  >
                    <NavbarItem
                      {...item.menu_action_items_id}
                      currentNavlink={currentPage}
                      onNavlinkClick={onNavlinkClick}
                      clickHeaderSub={clickHeaderSub}
                      getUrl={getUrl}
                      onCallAction={onCallAction}
                    />
                  </Box>
                ),
            )}
        </>
      )}
    </Flex>
  );
};
